import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const CostEstimatorResultSkeleton: React.FC = () => {
  return (
    // <div className="flex items-center space-x-4">
    //   <Skeleton className="h-12 w-12 rounded-full bg-primary" />
    //   <div className="space-y-2">
    //     <Skeleton className="h-4 w-[250px] bg-primary" />
    //     <Skeleton className="h-4 w-[200px] bg-primary" />
    //   </div>
    // </div>

    <Card>
      <CardContent>
        <div className="mt-4 flex flex-col items-start justify-between">
          <div className="flex h-14 w-full flex-row items-center justify-center gap-2">
            <Skeleton className="h-6 w-full bg-gray-200" />
          </div>

          <hr className="w-full bg-primary" />
          <div className="gap- flex h-32 w-full flex-col items-center justify-center gap-2">
            <Skeleton className="h-6 w-full bg-gray-200" />
            <Skeleton className="h-6 w-full bg-gray-200" />
            <Skeleton className="h-6 w-full bg-gray-200" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CostEstimatorResultSkeleton;
